import { logger } from '../logger/client'

import { StaticsAnalysis } from './StaticsAnalysis'

import type { AnalyticsInstance } from 'analytics'
import type { TEventName, TEventParams } from './types'
export class WebStaticsAnalysis extends StaticsAnalysis {
  constructor() {
    super()
  }

  private userId = ''

  private email_sha256 = ''

  /**
   * https://github.com/DavidWells/analytics/tree/master/packages/analytics-plugin-google-tag-manager
   */

  getAnalytics() {
    const analytics = (window as any)?.analytics as AnalyticsInstance
    if (!analytics) {
      logger.warn('analytics is not defined')
    }
    return analytics
  }

  getDataLayer() {
    const dataLayer = ((window as any)?.dataLayer || []) as Record<
      string,
      any
    >[]
    if (!dataLayer) {
      logger.warn('dataLayer is not defined')
      return
    }
    return dataLayer
  }

  public async updateUserId(userId: string) {
    const dataLayer = this.getDataLayer()
    if (!dataLayer) {
      return
    }
    dataLayer.push({
      user_id: userId,
    })
    this.userId = userId

    const analytics = this.getAnalytics()

    analytics?.identify(userId)
  }

  public async updateEmail(email_sha256: string) {
    const dataLayer = this.getDataLayer()
    if (!dataLayer) {
      return
    }

    this.email_sha256 = email_sha256
    dataLayer.push({
      email_sha256,
      user_data: {
        email_address: this.email_sha256,
      },
    })
  }

  public track = (eventName: TEventName, eventParams?: TEventParams) => {
    const windowDataLayer = this.getDataLayer()
    if (!windowDataLayer) {
      return
    }

    if (eventParams?.user_id) {
      this.updateUserId(eventParams?.user_id)
    }

    if (eventParams?.email_sha256) {
      this.updateEmail(eventParams?.email_sha256)
    }

    const dataLayer: Record<string, any> = {
      event: eventName,
      ...eventParams,
    }

    if (this.userId) {
      dataLayer.user_id = this.userId
      dataLayer.email_sha256 = this.email_sha256
      dataLayer.user_data = {
        email_address: this.email_sha256,
      }
    }
    windowDataLayer.push(dataLayer)

    const resetParams: typeof eventParams = {}

    if (eventParams) {
      for (const key in eventParams) {
        if (!['user_id', 'email_sha256', 'user_data'].includes(key)) {
          resetParams[key] = null
        }
      }
    }

    /* 上报后先把所有参数先清空 */
    windowDataLayer.push(resetParams)
  }

  public useTool(params: {
    tool_name?: string | null
    tool_id?: string | number
    model: 'GPT-3.5' | 'GPT-4' | 'HIX' | string | any
    value?: number
    application: 'Web' | 'Extension' | string
    application_category: //
    // Web
    | 'Website'
      | 'Dashboard'
      | 'HIX editor'
      // Extension
      | 'Google doc'
      | 'Others'

    page_url?: string
    category1:
      | 'AI tools'
      | 'AI writers'
      | 'ArticleGPT'
      | 'HIX editor action'
      | 'HIX email writer'
      | 'HIX chat'
      | 'Selected mode'
      | 'Social media'
      | 'Google doc action'
      | 'Gmail'
      | 'Bypass'
    category2: string

    step?: 'Reference' | 'Title' | 'Outline' | 'Product URL' | 'Article'
  }) {
    this.track(
      'use_tool',
      Object.assign(
        {
          page_url: window.location.href,
        },
        params,
      ),
    )
  }
}
